import type { Components } from '@mui/material/styles';

export default function MUIStack(): Components['MuiStack'] {
  return {
    defaultProps: {
      useFlexGap: true,
    },
  };
}
